import React, { useEffect, useState } from 'react';
import { Form, Modal, Select, message } from 'antd';
import emiter, {
	EVENT_VEHICLE_EXCHANGE_STORE,
	EVENT_VEHICLE_RESEARCH,
	EVENT_VEHICLE_SEARCH_SERIES, EVENT_VEHICLE_SEARCH_VEHICLE
} from '../../../../events';
import request from '../../../../request';
import { API_VEHICLE_GET_STORE, API_VEHICLE_EDIT_STORE } from '../../../../hooks/carRental/_';

interface PropsType {
	enums?: any;
}

const SPVehicleStoreModal: React.FC<PropsType> = props => {
	const mainFormFields = {
		diaozhimendian: {
			name: 'store_code',
			label: '调至门店',
			required: true,
			message: '请选择门店',
			placeholder: '请选择',
		},
	};

	const [form] = Form.useForm();

	const [showModal, setShowModal] = useState(false);
	const [code, setCode] = useState('');
	const [list, setList] = useState([]);
	const [currStoreCode, setCurrStoreCode] = useState('');

	const openModal = (data: any) => {
		setShowModal(true);
		setCode(data.veh_code);
		setCurrStoreCode(data.store_code);
	};

	const closeModal = () => {
		setShowModal(false);
		form.resetFields();
	};

	const getStoreList = () => {
		request({
			url: API_VEHICLE_GET_STORE,
			method: 'GET',
		}).then((res: any) => {
			setList(res.data);
		});
	};

	// 调整门店
	const changeStore = () => {
		form.validateFields().then((fieldsValue: any) => {
			request({
				url: API_VEHICLE_EDIT_STORE,
				method: 'POST',
				data: {
					veh_code: code,
					store_code: fieldsValue.store_code,
				},
			}).then((res: any) => {
				// 操作成功关闭弹窗，查询列表
				if (res.errno === 0 && res.data.is_success) {
					message.success('调换成功');
					closeModal();
					// 重新查询列表
					emiter.emit(EVENT_VEHICLE_RESEARCH);
				} else {
					message.error(res.errmsg || '调换门店失败');
				}
			});
		});
	};

	useEffect(() => {
		getStoreList();
		emiter.on(EVENT_VEHICLE_EXCHANGE_STORE, openModal);
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_EXCHANGE_STORE)
		}
	}, []);

	return (
		<Modal title="车辆调度" open={showModal} centered onCancel={closeModal} onOk={changeStore}>
			<Form form={form}>
				<Form.Item
					name={mainFormFields.diaozhimendian.name}
					label={mainFormFields.diaozhimendian.label}
					rules={[
						{
							required: mainFormFields.diaozhimendian.required,
							message: mainFormFields.diaozhimendian.message,
						},
					]}
				>
					<Select placeholder="请选择" showSearch optionFilterProp="children">
						{list &&
							list
								.filter((storeItem: any) => storeItem.store_code !== currStoreCode)
								?.map((item: any) => (
									<Select.Option key={item.store_code} value={item.store_code}>
										{item.store_name}
									</Select.Option>
								))}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default SPVehicleStoreModal;
